import { render, staticRenderFns } from "./ReviewApprove.vue?vue&type=template&id=38b391f9&scoped=true&"
import script from "./ReviewApprove.vue?vue&type=script&lang=js&"
export * from "./ReviewApprove.vue?vue&type=script&lang=js&"
import style0 from "./ReviewApprove.vue?vue&type=style&index=0&id=38b391f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b391f9",
  null
  
)

export default component.exports